<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="新增廠商" :visible.sync="dialogVisible" width="70%"
      :before-close="handleClose">
      <div>
        <el-form :model="form" :rules="rules" ref="adminForm" label-width="100px">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基本资料" name="first">
              <el-form-item label="角色" prop="role_id">
                <el-select v-model="form.role_id" style="width:100%;" placeholder="請選擇">
                  <el-option v-for="(item,index) in roleList" :key="index" :label="item.role_name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="廠商名稱" prop="name">
                <el-input v-model="form.name" placeholder="請輸入"></el-input>
              </el-form-item>

              <el-form-item label="廠商LOGO" prop="realname">
                <Upload ref="upload" @change="uploadChange" :limit="1"></Upload>
              </el-form-item>
              <el-form-item label="類型"  >
                 <el-radio-group v-model="form.type">
                    <el-radio :label="1">設備類</el-radio>
                    <el-radio :label="2">勤務類</el-radio>
                  </el-radio-group>
              </el-form-item>

              <!-- <el-form-item label="有效日期" prop="validAt">
                  <el-date-picker v-model="form.validAt" type="datetime" placeholder="選擇日期時間"
                    value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59">
                  </el-date-picker>
                </el-form-item> -->

              <!-- <el-form-item label="帳號" prop="username">
                  <el-input v-model="form.username" placeholder="請輸入"></el-input>
                </el-form-item>
 -->
             <!-- <el-form-item label="設備MAC" prop="mac">
                <el-input v-model="form.mac" placeholder="請輸入"></el-input>
              </el-form-item> -->

              <el-form-item label="廠商編號" prop="number">
                <el-input v-model="form.number" placeholder="請輸入"></el-input>
              </el-form-item>

             <!-- <el-form-item label="SSID" prop="ssid">
                <el-input v-model="form.ssid" placeholder="請輸入"></el-input>
              </el-form-item> -->



              <!-- <el-form-item label="密碼" prop="password">
                  <el-input v-model="form.password" type="password" placeholder="請輸入"></el-input>
                </el-form-item> -->
            </el-tab-pane>
            <el-tab-pane label="分组" name="second">
              <el-form-item label="分组">
                <el-table :data="form.groupList" border style="width: 100%" size="small"
                  :header-cell-style="headerStyle">
                  <el-table-column prop="id" label="分组编号" align="center"></el-table-column>
                  <el-table-column prop="groupName" label="分组名稱" align="center"></el-table-column>
                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button type="danger" size="small" plain @click="delProduct(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="mr-t15">
                  <el-button type="primary" plain @click="addGroups">+ 选择分组</el-button>
                </div>
                <ProductDialog @submit="chooseGroups" ref="groups"></ProductDialog>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">確 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Upload from "@/components/upload/Upload"
  import ProductDialog from "@/components/group/groupDialog"
  export default {
    components: {
      Upload,
      ProductDialog
    },
    props: {
      dialogVisible: {
        type: Boolean,
        default: false
      },
      roleList: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        headerStyle: {
          'background': '#f9f9f9',
          'color': '#666'
        },
        activeName: 'first',
        form: {
          username: "",
          name: "",
          role_id: '',
          password: "",
          mac: "",
          ssid: '',
          validAt: "",
          logo: '',
          name: '',
          groupIds: '',
          groupList: [],
          type: '',
          number:'',
        },
        rules: {
          username: [{
            required: true,
            message: "用戶名不能爲空",
            trigger: "blur"
          }],

          role_id: [{
            required: true,
            message: "角色不能爲空",
            trigger: "blur"
          }],
          password: [{
            required: true,
            message: "密碼不能爲空",
            trigger: "blur"
          }],
          name: [{
            required: true,
            message: "廠商名稱不能爲空",
            trigger: "blur"
          }],

        }
      }
    },
    created() {

    },
    methods: {
      //删除推荐商品
      delProduct(index) {
        this.form.groupList.splice(index, 1);
        this.form.groupIds = [];
        this.form.groupList.forEach((item) => {
          this.form.groupIds.push(item.id);
        })
        this.form.groupIds = this.form.groupIds.join(",")
      },
      chooseGroups(data) {
        console.log(data)
        this.form.groupList = [...this.form.groupList, ...data];
        let obj = {};
        this.form.groupList = this.form.groupList.reduce((newArr, next) => {
          obj[next.id] ? "" : (obj[next.id] = true && newArr.push(next));
          return newArr;
        }, []);
        this.form.groupIds = [];
        this.form.groupList.forEach((item) => {
          this.form.groupIds.push(item.id);
        })
        this.form.groupIds = this.form.groupIds.join(",")
      },
      addGroups() {
        this.$refs.groups['visible'] = true;
      },

      handleClick(tab, event) {
        console.log(tab, event);
      },
      uploadChange(data) {
        this.form.logo = data;
      },
      submit() {
        this.$refs.adminForm.validate((valid) => {
          if (valid) {
            this.$request({
              url: this.$api.admin.create,
              method: "post",
              data: this.form
            }).then((res) => {
              if (res.data.code == 1) {
                this.$message.success(res.data.msg);
                this.form = {
                  username: "",
                  name: "",
                  role_id: '',
                  password: "",
                  mac: "",
                  validAt: "",
                  logo: '',
                  name: '',
                  ssid: '',
                  type: '',
                  number:'',
                }
                this.$emit("success");
              } else {
                this.$message.error(res.data.msg);
              }
            }).catch((err) => {
              this.$message.error("请求失败");
            })
          } else {
            return false;
          }
        })

      },
      handleClose() {
        this.$emit("close");
        this.form = {
          username: "",
          name: "",
          role_id: '',
          password: "",
          mac: "",
          validAt: "",
          logo: '',
          name: '',
          ssid: '',
          groupList: [],
          number:'',
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/settings/admin/AdminCreateModal.vue